import Types from "Types";
import {
  ActionType,
  createAsyncAction,
  createAction,
  getType,
} from "typesafe-actions";
import {
  Bien,
  BienDetail,
  NombrePieces,
  TypeBien,
} from "../../services/Api/swagger";

export interface BienState {
  data?: BienDetail;
  typesBien?: TypeBien[];

  bienFetchInfo: Types.IFetchInfos;
  typeBienFetchInfo: Types.IFetchInfos;

  nombrePieces?: NombrePieces[];
  nombrePiecesFetchInfo: Types.IFetchInfos;
}

/**
 * Init value est temporaire en attentant
 * l'US de récupération du dossier de location
 */
export const initialState: BienState = {
  data: undefined,
  bienFetchInfo: {
    fetching: false,
    error: undefined,
  },
  typesBien: undefined,
  typeBienFetchInfo: {
    fetching: false,
    error: undefined,
  },
  nombrePieces: undefined,
  nombrePiecesFetchInfo: {
    fetching: false,
    error: undefined,
  },
};

export const addBienAsync = createAsyncAction(
  "@@App/bien/ADD_REQUEST",
  "@@App/bien/ADD_SUCCESS",
  "@@App/bien/ADD_FAILURE"
)<{ bien: Bien; form: string }, BienDetail, any>();

export const updateBienAsync = createAsyncAction(
  "@@App/bien/UPDATE_REQUEST",
  "@@App/bien/UPDATE_SUCCESS",
  "@@App/bien/UPDATE_FAILURE"
)<{ bien: Bien; form: string }, BienDetail, any>();

export const lancerChargementBien = createAction(
  "@@App/bien/PREREMPLIR_SUCCESS"
)<BienDetail>();

export const removeError = createAction(
  "@@app/bien/supprimerBienErrors"
)<void>();

export const loadTypeBienAsync = createAsyncAction(
  "@@App/bien/types/LOAD_REQUEST",
  "@@App/bien/types/LOAD_SUCCESS",
  "@@App/bien/types/LOAD_FAILURE"
)<void, TypeBien[], any>();

export const loadNombrePieces = createAsyncAction(
  "@@App/bien/nombrePieces/LOAD_REQUEST",
  "@@App/bien/nombrePieces/LOAD_SUCCESS",
  "@@App/bien/nombrePieces/LOAD_FAILURE"
)<void, NombrePieces[], any>();

export const resetBienParcoursCreation = createAction(
  "@@App/bien/PARCOURS_CREATION/RESET_STORE"
)<void>();

export const ActionCreators = {
  addBienAsync,
  updateBienAsync,
  lancerChargementBien,
  loadNombrePieces,
  removeError,
  resetBienParcoursCreation,
};

const getBien = (state: Types.RootState): BienDetail | undefined =>
  state.bien.data;

const getBienFetching = (state: Types.RootState): boolean =>
  state.bien.bienFetchInfo.fetching;
const getBienError = (state: Types.RootState): boolean =>
  state.bien.bienFetchInfo.error;

const getTypesBien = (state: Types.RootState): any | undefined =>
  state.bien.typesBien;

const getTypesBienFetching = (state: Types.RootState): boolean =>
  state.bien.typeBienFetchInfo.fetching;

const getTypesBienError = (state: Types.RootState): any =>
  state.bien.typeBienFetchInfo.error;

const getNombrePieces = (state: Types.RootState): any | undefined =>
  state.bien.nombrePieces;

const getNombrePiecesFetching = (state: Types.RootState): boolean =>
  state.bien.nombrePiecesFetchInfo.fetching;

const getNombrePiecesError = (state: Types.RootState): any | undefined =>
  state.bien.nombrePiecesFetchInfo.error;

export const Selectors = {
  getBien,
  getBienFetching,
  getBienError,
  getTypesBien,
  getTypesBienFetching,
  getTypesBienError,
  getNombrePieces,
  getNombrePiecesFetching,
  getNombrePiecesError,
};

export const reducer = (
  state: BienState = initialState,
  action: ActionType<typeof ActionCreators>
): BienState => {
  switch (action.type) {
    case getType(addBienAsync.request):
      return {
        ...state,
        bienFetchInfo: {
          fetching: true,
          error: undefined,
        },
      };
    case getType(addBienAsync.success):
      return {
        ...state,
        data: action.payload,
        bienFetchInfo: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(addBienAsync.failure):
      return {
        ...state,
        bienFetchInfo: {
          fetching: false,
          error: action.payload,
        },
      };

    case getType(updateBienAsync.request):
      return {
        ...state,
        bienFetchInfo: {
          fetching: true,
          error: undefined,
        },
      };
    case getType(updateBienAsync.success):
      return {
        ...state,
        data: action.payload,
        bienFetchInfo: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(updateBienAsync.failure):
      return {
        ...state,
        bienFetchInfo: {
          fetching: false,
          error: action.payload,
        },
      };
    case getType(lancerChargementBien):
      return {
        ...state,
        // data: preremplirFormulaire(action.payload, state.data),
        bienFetchInfo: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(loadNombrePieces.request):
      return {
        ...state,
        nombrePiecesFetchInfo: {
          fetching: true,
          error: undefined,
        },
      };
    case getType(loadNombrePieces.success):
      return {
        ...state,
        nombrePieces: action.payload,
        nombrePiecesFetchInfo: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(loadNombrePieces.failure):
      return {
        ...state,
        nombrePiecesFetchInfo: {
          fetching: false,
          error: action.payload,
        },
      };

    case getType(removeError):
      return {
        ...state,
        bienFetchInfo: {
          fetching: false,
          error: undefined,
        },
      };
    case getType(resetBienParcoursCreation):
      return {
        ...state,
        data: undefined,
        bienFetchInfo: {
          fetching: false,
          error: undefined,
        },
      };
    default:
      return state;
  }
};

export const preremplirFormulaire = (
  newBien: BienDetail,
  bienState?: BienDetail
): BienDetail => {
  const {
    dateCreation,
    dateModification,
    identifiant,
    garantieLi,
    ...newBien2
  } = newBien;
  if (bienState && bienState.identifiant) {
    const newBienCopie2 = newBien2 as BienDetail;
    newBienCopie2.identifiant = bienState.identifiant;
    return newBienCopie2;
  } else {
    return { ...newBien2, garantieLi: true };
  }
};
